'use client';

import ResponsiveImage from '@/components/ResponsiveImage';
import useIsPageInteractive from '@/hooks/useIsPageInteractive';
import useIntersectionObserver from '@/hooks/useIntersectionObserver';
import { useCallback, useEffect } from 'react';

export const Media = ({ file = {} }) => {
  const [videoRef, isIntersecting] = useIntersectionObserver();

  const { mime } = file;

  useEffect(() => {
    if (isIntersecting) {
      videoRef.current.play();
    }
  }, [videoRef, isIntersecting]);

  const loadVideo = useCallback(() => {
    videoRef.current.play();
  }, [videoRef]);

  useIsPageInteractive(loadVideo);

  if (mime?.startsWith('image/')) {
    return (
      <ResponsiveImage
        file={file}
        className='fok-media-item -translate-y-[var(--image-translate-y)] -mb-[var(--image-translate-y)] w-[80%] sm:w-auto max-w-[17rem] lg:max-w-sm object-contain mx-auto sm:mx-0'
      />
    );
  }

  if (mime?.startsWith('video/')) {
    return (
      <video
        ref={videoRef}
        className='fok-media-item fok-video-player -translate-y-[var(--image-translate-y)] -mb-[var(--image-translate-y)] max-w-[300px] md:max-w-[min(80%,17.5rem)] md:w-full object-cover block mx-auto lg:mx-0'
        autoPlay={false}
        loop
        muted
        playsInline
        preload='none'
      >
        <source src={file.url} type={file.mime} />
      </video>
    );
  }

  return <></>;
};
